/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CabinClass,
    CabinClassFromJSON,
    CabinClassFromJSONTyped,
    CabinClassToJSON,
} from './';

/**
 * 
 * @export
 * @interface CabinClassTTLOCriteriaInput
 */
export interface CabinClassTTLOCriteriaInput {
    /**
     * 
     * @type {boolean}
     * @memberof CabinClassTTLOCriteriaInput
     */
    exclude?: boolean;
    /**
     * 
     * @type {CabinClass}
     * @memberof CabinClassTTLOCriteriaInput
     */
    value?: CabinClass;
}

export function CabinClassTTLOCriteriaInputFromJSON(json: any): CabinClassTTLOCriteriaInput {
    return CabinClassTTLOCriteriaInputFromJSONTyped(json, false);
}

export function CabinClassTTLOCriteriaInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinClassTTLOCriteriaInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
        'value': !exists(json, 'value') ? undefined : CabinClassFromJSON(json['value']),
    };
}

export function CabinClassTTLOCriteriaInputToJSON(value?: CabinClassTTLOCriteriaInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exclude': value.exclude,
        'value': CabinClassToJSON(value.value),
    };
}


